import { useMutation, useQuery } from '@tanstack/react-query';

import { UserSettingsRepo } from '../services/user-settings-repo';

const queryKey = 'user-settings';

export const useUserSettings = () => {
  const getUserSettingsQuery = useQuery({
    queryKey: [queryKey],
    gcTime: Infinity,
    staleTime: Infinity,

    queryFn: UserSettingsRepo.get,
  });

  const updateUserSettingsMutation = useMutation({
    mutationKey: [queryKey],
    gcTime: Infinity,

    mutationFn: UserSettingsRepo.update,
    onSuccess: () => {
      // Invalidate user settings query to refetch updated data
      getUserSettingsQuery.refetch();
    },
  });

  return {
    getUserSettingsQuery,
    updateUserSettingsMutation,
  };
};
